/* eslint-disable no-unreachable */
/* eslint-disable no-case-declarations */
/* eslint-disable react/prop-types */
import React, { useState } from "react"; //import the component part of React
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
//Google Tag Manager
import TagManager from "react-gtm-module";

//Class/Participant Data is passed to the form with as "data" so can be called like "props.data.participant_id"

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#43ac6a",
      color: "#43ac6a",
      fontWeight: 900,
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "#43ac6a" },
      "::placeholder": { color: "#43ac6a" },
    },
    invalid: {
      iconColor: "#ff0f0f",
      color: "#ff0f0f",
    },
  },
};

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [isDisabled, setDisabled] = useState(0);
  const [message, _setMessages] = useState("");

  // helper for displaying status messages.
  const setMessage = (message) => {
    _setMessages(`${message}\n\n`);
  };

  const tryAgain = async () => {
    setDisabled(0);
    _setMessages("");
  };

  const handleSubmit = async (event) => {
    // Block native form submission which can reload our page
    event.preventDefault();
    setDisabled(1);

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      // show error and collect new card details.
      return setMessage(error.message);
    }

    const subData = {
      paymentMethodId: paymentMethod.id,
      class_id: props.classData._id,
      participant_id: props.selectedParticipant,
      couponCode: props.couponCode,
    };

    // Create the Subscription
    const subscriptionObject = await axios.post(
      `/api/customer/checkout/subscribe/${props.endpoint}/`,
      subData,
      {
        withCredentials: true,
      }
    );

    if (subscriptionObject.status !== 200) {
      // show error and collect new card details.
      return setMessage(subscriptionObject.response.data.subError.message);
    }

    // Declare the subscription
    const subscription = subscriptionObject.data.subscription;
    const price = parseFloat(props.classData.Price).toFixed(2);

    switch (props.classData.Prorate) {
      case true: //Check if the class is already running, if it is trigger the proration flow to adjust for missed classes
        switch (
          subscription.status //Check the subscription status for if SCA is needed.
        ) {
          case "active":
            TagManager.dataLayer({
              dataLayer: {
                event: "purchase",
                ecommerce: {
                  transaction_id: subscription.id,
                  value: price,
                  currency: props.currency,
                  items: [
                    {
                      item_name: props.classData.LessonType,
                      quantity: 1,
                      item_category: "subscription",
                      price: price,
                    },
                  ],
                },
              },
            });
            return navigate(`/success/`);
            break;

          case "trialing":
            TagManager.dataLayer({
              dataLayer: {
                event: "purchase",
                ecommerce: {
                  transaction_id: subscription.id,
                  value: price,
                  currency: props.currency,
                  items: [
                    {
                      item_name: props.classData.LessonType,
                      quantity: 1,
                      item_category: "subscription",
                      price: price,
                    },
                  ],
                },
              },
            });
            return navigate(`/success/`);
            break;

          case "incomplete":
            //Send for SCA
            const { error } = await stripe.confirmCardPayment(
              subscription.latest_invoice.payment_intent.client_secret
            );
            //Handle Errors
            if (error) {
              setMessage(`${error.message} You will now be redirected to your dashboard.`);
              return setTimeout(() => navigate(`/dashboard/`), 3000); 
            } else {
              TagManager.dataLayer({
                dataLayer: {
                  event: "purchase",
                  ecommerce: {
                    transaction_id: subscription.id,
                    value: price,
                    currency: props.currency,
                    items: [
                      {
                        item_name: props.classData.LessonType,
                        quantity: 1,
                        item_category: "subscription",
                        price: price,
                      },
                    ],
                  },
                },
              });
              return navigate(`/success/`);
            }
            break;

          default:
           return setMessage("Unknown subscription status. Please contact support.")
        }
        break;

      case false: //Check if the class has proration logic enabled, if it is trigger the proration flow to adjust for missed classes
        switch (
          subscription.status //Check the subscription status for if SCA is needed.
        ) {
          case "active":
            TagManager.dataLayer({
              dataLayer: {
                event: "purchase",
                ecommerce: {
                  transaction_id: subscription.id,
                  value: price,
                  currency: props.currency,
                  items: [
                    {
                      item_name: props.classData.LessonType,
                      quantity: 1,
                      item_category: "subscription",
                      price: price,
                    },
                  ],
                },
              },
            });
            return navigate(`/success/`);
            break;

          case "trialing":
            //There is a case when subscription proration behaviour isn't on but the subscription goes to trialing without SCA
            if (subscription.pending_setup_intent === null) {
              // Check for a pending setupintent - if not, probably successful.
              TagManager.dataLayer({
                dataLayer: {
                  event: "purchase",
                  ecommerce: {
                    transaction_id: subscription.id,
                    value: price,
                    currency: props.currency,
                    items: [
                      {
                        item_name: props.classData.LessonType,
                        quantity: 1,
                        item_category: "subscription",
                        price: price,
                      },
                    ],
                  },
                },
              });
              return navigate(`/success/`);
            } else {
              //Send for SCA if there is a pending setup intent
              const { error } = await stripe.confirmCardSetup(
                subscription.pending_setup_intent.client_secret
              );
              //Handle Errors
              if (error) {
                setMessage(error.message);
              } else {
                TagManager.dataLayer({
                  dataLayer: {
                    event: "purchase",
                    ecommerce: {
                      transaction_id: subscription.id,
                      value: price,
                      currency: props.currency,
                      items: [
                        {
                          item_name: props.classData.LessonType,
                          quantity: 1,
                          item_category: "subscription",
                          price: price,
                        },
                      ],
                    },
                  },
                });
                return navigate(`/success/`);
              }
            }
            break;

          case "incomplete":
            setMessage(error.message);

            break;
          default:
            setMessage(`Unknown Subscription status: ${subscription.status}`);
            break;
        }
    }
  };

  return (
    <Form onSubmit={handleSubmit} className='shadow mt-4 p-3 border'>
      <div className='FormRow'>
        <CardElement options={CARD_OPTIONS} />
      </div>
      <Button
        variant='success'
        size='lg'
        className='mt-3 mb-4 w-100'
        type='submit'
        disabled={!stripe || isDisabled}
      >
        {isDisabled ? "Processing..." : "Subscribe"}
      </Button>
      {message.length >= 1 ? (
        <div className='alert alert-danger mb-3' role='alert'>
          <span>
            {message}
            <br />
            <Button variant='secondary' size='sm' onClick={tryAgain} type='button'>
              Try Again
            </Button>
          </span>
        </div>
      ) : (
        " "
      )}
    </Form>
  );
};

export default CheckoutForm;
